export default "__VITE_ASSET__C37ExEmc__"